export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_05.c06c2c66.png";